export const MARKETPLACE_SUBTITLE =
  'pdp.collection_prompt.marketplace_subtitle';
export const SHOP_MARKETPLACE = 'pdp.collection_prompt.shop_marketplace';
export const SHOP_AVAILABLE_PRODUCTS =
  'pdp.collection_prompt.shop_available_products';
